<template>
  <DataTable default-to-primera :headers="headers" :path="path" :properties="properties" :filterPath="filterPath" filter ref="datatable">
    <span slot="after-filters">
      <v-tooltip bottom>
        <v-btn slot="activator" icon @click="downloadExcel" flat>
          <v-icon color="primary">far fa-file-excel</v-icon>
        </v-btn>
        <span>Descargar XLS</span>
      </v-tooltip>
    </span>
  </DataTable>
</template>

<script>
import DataTable from '../../../common/ui/DataTable'
import { downloadFileMixin } from '../../../mixins/downloadFileMixin'
import { paginationMixin } from '../../../mixins/paginationMixin'

export default {
  mixins: [downloadFileMixin, paginationMixin],

  components: {
    DataTable
  },

  data () {
    return {
      headers: [
        { text: 'Desde Apertura', value: 'fromDate', sortable: false, align: 'left', dateFilterField: true, visible: false },
        { text: 'Hasta Apertura', value: 'toDate', sortable: false, align: 'left', dateFilterField: true, visible: false },
        { text: 'Club', value: 'club', sortable: false, align: 'left', filterField: true },
        { text: 'Nro. Expediente', value: 'code', sortable: false, align: 'left' },
        { text: 'Fecha de apertura', value: 'date', sortable: false, align: 'left' },
        { text: 'Última modificación', value: 'modified', sortable: false, align: 'left' },
        { text: 'Etapa', value: 'status', sortable: false, align: 'left', filterField: true },
        { text: 'Asignación', value: 'assignee', sortable: false, align: 'left' },
        { text: 'Juez', value: 'user', sortable: false, align: 'left' }
      ],
      properties: ['club', 'code', 'date', 'modified', 'status', 'assignee', 'user'],
      path: 'expedientes/list',
      filterPath: 'filters/case_file'
    }
  },

  methods: {
    getExcelPath () {
      return 'expedientes/xls' + '?' + this.$refs.datatable.getFilteringPath().substring(1)
    },
    getFilenamePrefix () {
      return 'expedientes'
    }
  }
}

</script>

<style scoped>

</style>
